import React from "react";

import { Props } from "./Section.types";
import * as Styled from "./Section.styled";

/**
 * Bolt is a visual element that can be added to the end of the section
 */
export const Section: React.FC<React.PropsWithChildren<Props>> = ({
  bolt,
  children,
  ...section
}) => {
  return (
    <Styled.Section
      id={section.id}
      $color={section.color}
      $backgroundColor={section.backgroundColor}
      $backgroundImage={section.backgroundImage}
      $overflowHidden={section.overflowHidden}
    >
      {children}

      {!!bolt && <Styled.Bolt $variant={bolt.variant} $color={bolt.color} />}
    </Styled.Section>
  );
};
